export default __webpack_public_path__ + "static/media/psych.80a978ce.jpg";